export default __webpack_public_path__ + "static/media/Printer.feba2b56.svg";